import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import { memo } from 'react'
import type { IconProps } from '.'

const AccountCircleOutlined = memo((props: IconProps) => {
    const { color, title } = props
    return (
        <AccountCircleOutlinedIcon
            data-testid="Icon__AccountCircleOutlined"
            css={{ color }}
            titleAccess={title}
        />
    )
})

export default AccountCircleOutlined
